var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { borderRadius } from '../../styles/borderRadius';
import { colors } from '../../styles/colors';
import { getShadow } from '../../styles/shadows';
export var StyledCardContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  transition: box-shadow 0.2s ease-in-out;\n  ", "\n  ", "\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  transition: box-shadow 0.2s ease-in-out;\n  ", "\n  ", "\n"])), colors.white, borderRadius.md, function (_a) {
    var $level = _a.$level, $shadowStrength = _a.$shadowStrength;
    var strength = $level ? Number($level) / 10 : $shadowStrength;
    return getShadow(strength);
}, function (_a) {
    var $variant = _a.$variant, $shadowStrength = _a.$shadowStrength;
    return $variant === 'hoverable' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        ", ";\n      }\n    "], ["\n      &:hover {\n        ", ";\n      }\n    "])), getShadow($shadowStrength + 1));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Card.styles.js.map